import styled from 'styled-components';
import Button from 'react-bootstrap/Button';

interface Props {
  color?: string;
}
export const ButtonStyled = styled(Button)<Props>`
  min-width: 132px;
  height: 36px;
  background-color: ${({ color }) => color || '#4A90E2'};
  border-radius: 18px;
  border: 0;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 10px;
  letter-spacing: 0.5px;      
  color: #FFFFFF;

  &:focus {
    box-shadow: none;
  }

  &.disabled, &:disabled{
    opacity: .5;
    border: 0;
    background-color: ${({ color }) => color || '#4A90E2'};
  }

  &.right {
    width: 132px;
    display: flex;
    align-self: flex-end;
    align-items: center;
    justify-content: center;
    margin: 0;
  }
`;